export const environment = {
    production: false,
    authPortalUrl: 'https://auth-dev.kphotolavie.com/login',
    userPortalUrl: 'https://my-dev.kphotolavie.com',
    configUrl: 'https://getenvironment-g4sntxau3q-uc.a.run.app',
    // DEPRECATED: Configuration is now loaded from ConfigService. 
    // This is kept to prevent compilation errors during migration.
    firebasePhotoLavie: {
        apiKey: "",
        authDomain: "",
        projectId: "",
        storageBucket: "",
        messagingSenderId: "",
        appId: ""
    }
};
